export default __webpack_public_path__ + "static/media/avatar.dafbc1f9.svg";